// extracted by mini-css-extract-plugin
module.exports = {"container":"Computer_container__2wPoZ","content":"Computer_content__2ODmH","circlePulse":"Computer_circlePulse__3YqW4"};